document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.image-slider__container .swiper').forEach((slider) => {
        const section = slider.closest('.image-slider__container');
        
        if (slider.classList.contains('swiper-initialized')) return;

        const swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 7,
            draggable: false,
            scrollbar: {
                el: section.querySelector('.swiper-scrollbar'),
                draggable: true,
            },
            navigation: {
                nextEl: section.querySelector('.swiper-arrow--next'),
                prevEl: section.querySelector('.swiper-arrow--prev'),
            },
            breakpoints: {
                750: { 
                    slidesPerView: 2, 
                    spaceBetween: 10, 
                }
            }
        });
    });
});